import { Component, Inject, OnInit } from "@angular/core";
import {
  MatSnackBar,
  MatSnackBarRef,
  SimpleSnackBar,
  MAT_SNACK_BAR_DATA,
} from "@angular/material/snack-bar";
import { MyUtils } from "src/app/services/my-utils.service";

@Component({
  selector: "app-snackbar-or",
  templateUrl: "./snackbar-or.component.html",
})
export class SnackbarORComponent implements OnInit {
  ngOnInit(): void {}
  constructor(public snackBarRef: MatSnackBarRef<SnackbarORComponent> , public utils: MyUtils) {}
}
